import { render, staticRenderFns } from "./operational_dashboard.vue?vue&type=template&id=b5630aa0&scoped=true"
import script from "./operational_dashboard.vue?vue&type=script&lang=js"
export * from "./operational_dashboard.vue?vue&type=script&lang=js"
import style0 from "./operational_dashboard.vue?vue&type=style&index=0&id=b5630aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5630aa0",
  null
  
)

export default component.exports